import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  numberAttribute,
} from '@angular/core';

@Component({
  selector: 'iw-shimmer',
  templateUrl: './shimmer.component.html',
  styleUrl: './shimmer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShimmerComponent {
  count = input(5, { transform: numberAttribute });
  height = input(48, { transform: numberAttribute });
  gap = input(4, { transform: numberAttribute });
  width = input();
  direction = input('column');

  columns = computed(() => Array.from({ length: this.count() }));
}
